import {addClass, findAll, wrap} from "../../../../../modules/vegas/js/util";

function onReady() {
	let pages = findAll('.page-default');
	if (pages.length) {
		[...pages].map((page) => {
			// image
			let images = findAll('img', page);
			if (images && images.length) {
				[...images].map((img) => {
					addClass(img, 'img-fluid')
				})
			}

			let imagesFancy = findAll('a[href=""][data-fancybox] img', page);
			if (imagesFancy && imagesFancy.length) {
				[...imagesFancy].map((img) => {
					let a = img.closest('a');
					a.setAttribute('href', img.getAttribute('src'));
				})
			}

			// table
			let tables = findAll('table', page);
			if (tables && tables.length) {
				[...tables].map((table) => {
					addClass(table, ['table', 'table-hover', 'table-bordered'])
					wrap(table, 'table-responsive');
				})
			}
		})
	}
};

document.addEventListener('DOMContentLoaded', onReady);
onTurboRender(onReady);
